import styled from '@emotion/styled'

export const SLoadingWrapper = styled.div`
  position: absolute;
  top: var(--p-spacing);
  bottom: var(--p-spacing);
  display: flex;
  align-items: center;
`
